import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Box, Stack, Drawer, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useResponsive from '../../../hooks/useResponsive';
// config
import { NAV, HEADER } from '../../../config-global';
// components
import Scrollbar from '../../../components/scrollbar';
import Iconify from '../../../components/iconify';
import { NavSectionVertical } from '../../../components/nav-section';
//
import navConfig from './config-navigation';
import AllPagesNavAccount from './AllPagesNavAccount';
import AppCache from '../../../services/appcache';
import HelpService from '../../../services/helpandcommunication.service';
// --------------------------------------------------------------------------------------------------------

const StyledLogo = styled('div')(({ theme }) => ({
    width: NAV.W_DASHBOARD,
    height: HEADER.H_DASHBOARD_DESKTOP,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2, 2.5),
    backgroundColor: theme.palette.primary.main,
}));
// --------------------------------------------------------------------------------------------------------

AllPagesNavbar.propTypes = {
    openNav: PropTypes.bool,
    onOpenNav: PropTypes.func,
    onCloseNav: PropTypes.func,
    navWidth: PropTypes.number,
};
// --------------------------------------------------------------------------------------------------------

export default function AllPagesNavbar({ openNav, onOpenNav, onCloseNav, navWidth }) {

    const { pathname } = useLocation();
    const isDesktop = useResponsive('up', 'lg');
    const [category, setCategory] = useState('');

    useEffect(() => {
        if (isDesktop && openNav) {
            onOpenNav();
        }
        else {
            onCloseNav();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        //  if (pathname.split('/')[2] === "data") {
        if (pathname.split('/')[3] === "inventorypage" || pathname.split('/')[3] === "grosssalepage") {
            onCloseNav();
        }
        else {
            onOpenNav();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    useEffect(() => {
        const userLoginDetails = AppCache.GetUserLoginDetails();
        const payload = {
            franchise: userLoginDetails?.Franchise,
            region: userLoginDetails?.Region
        }
        HelpService.GetCategories(payload)
            .then((response) => {
                if (response.status === 200) {
                    // setCategory(response.data[0].categoryName);
                    // setCategory(response.data[0].category);
                    navConfig[0].items.forEach(item => {
                        if (item.path.includes('/helpandcommunication/home/JJ Core')) {
                            item.path = item.path.replace('JJ Core', response.data.length !== 0 ? response.data[0].category : '');
                        }
                    });
                }
                else {
                    // TODO: Handle error and show it to user
                    console.log("error");
                }
            })
            .catch(_error => {
                // handleError(_error, navigate, "", setLoading);
            });
    }, []);

    if (!AppCache?.GetCurrentLoggedInUser()?.IsHnCActive) {
        const filteredItems = navConfig[0].items.filter(item => item.title.toLowerCase().replace(/\s+/g, '') !== "helpandcommunication")
        // console.log('filteredItems:', filteredItems)

        navConfig[0].items = filteredItems;
        // console.log('navConfig:', navConfig)
    }
    /* else if (category) {
         navConfig[0].items.forEach(item => {
             if (item.path.includes('/helpandcommunication/home/JJ Core')) {
                 item.path = item.path.replace('JJ Core', category);
             }
         });
     }   */

    const renderContent = (
        <Scrollbar
            sx={{
                height: 1,
                '& .simplebar-content': {
                    height: 1,
                    display: 'flex',
                    flexDirection: 'column',
                },
                pb: 2.5
            }}
        >
            <Stack
                spacing={1}
                sx={{
                    flexShrink: 0,
                }}
            >
                <StyledLogo>
                    <img src='/logo/JJ-CORE-Logowhite.png' alt='' style={{ width: 165, height: 45, objectFit: 'contain' }} />
                </StyledLogo>
                <AllPagesNavAccount />
            </Stack>

            {/* <NavSectionVertical data={AppCache?.GetCurrentLoggedInUser()?.IsHnCActive ? navConfig : navConfig[0].items.filter(item => item.title.toLowerCase().replace(/\s+/g, '') !== "helpandcommunication")} /> */}
            <NavSectionVertical data={navConfig} />

            <Box sx={{ flexGrow: 1 }} />
        </Scrollbar>
    );

    return (
        <Box
            component="nav"
            sx={{
                flexShrink: { lg: 0 },
                width: { lg: navWidth },
            }}
        >
            {isDesktop && openNav &&
                <IconButton
                    sx={{
                        p: 0.5,
                        top: 32,
                        position: 'fixed',
                        left: NAV.W_DASHBOARD - 12,
                        bgcolor: 'background.default',
                        zIndex: (theme) => theme.zIndex.appBar + 1,
                        border: (theme) => `dashed 1px ${theme.palette.divider}`,
                        '&:hover': {
                            bgcolor: 'background.default',
                        },
                    }}
                    onClick={onCloseNav}
                >
                    <Iconify width={16} icon='eva:arrow-ios-back-fill' />
                </IconButton>
            }

            {isDesktop ? (
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    variant="permanent"
                    PaperProps={{
                        sx: {
                            zIndex: 0,
                            width: navWidth,
                            bgcolor: 'background.paper',
                            borderRightStyle: 'dashed',
                        },
                    }}
                >
                    {renderContent}
                </Drawer>
            ) : (
                <Drawer
                    open={openNav}
                    onClose={onCloseNav}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    PaperProps={{
                        sx: {
                            width: navWidth,
                        },
                    }}
                >
                    {renderContent}
                </Drawer>
            )}
        </Box>
    );
}
